import * as React from "react";
import './ChooseDetail.css';

interface ChooseDetailProps {
    title: string;
    actionText: string;
    link: string;
    handleClick: any;
}

export function ChooseDetail(props: ChooseDetailProps) {
    return <div className="row p-4 mx-1 choose-detail">
        <div className="col-12">
            <div className="row justify-content-between">
                <div className="col-12 col-md-5 col-lg-12 col-xl-5 mb-4 mb-md-0 px-0">
                    <h2 className="mb-0 choose-detail__title"><b>{ props.title }</b></h2>
                </div>
                <div className="col-12 col-md-7 col-lg-12 col-xl-7 text-left text-md-right px-0">
                    <button className="btn choose-detail__button btn-outline-red" onClick={() => props.handleClick(props.link)}>
                        <span>{ props.actionText }</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
}